<div class="page px-2 my-2">
  <div class="text-center" *ngIf="!hideHeader">
    <img src="/assets/logos/brand-logo-alt.svg" [alt]="brandName" height="100">
  </div>

  <ua-provisional-account-flow *ngIf="provisionalAccountId && provisionalEmail"
                               [accountId]="provisionalAccountId"
                               [email]="provisionalEmail"
                               [lastName]="lastName"
                               [phoneNumber]="phoneNumber"
                               (cancelClicked)="cancelProvisional()"
  ></ua-provisional-account-flow>

  <div *ngIf="!signup && !(provisionalAccountId && provisionalEmail)">
    <ua-login-form (cancelClicked)="cancelLogin()"
                   [username]="username"
                   (provisionalAccountDetected)="startProvisionalFlow($event)"
                   >
    </ua-login-form>
  </div>

  <ua-signup-form *ngIf="signup && !(provisionalAccountId && provisionalEmail)"
                  (signUpClicked)="createAccount($event)"
                  (backClicked)="cancel()"
                  (existingUserDetected)="toggleMode($event)"
                  (provisionalAccountDetected)="startProvisionalFlow($event)"
                  [showTitle]="showTitle"
                  [emailAddress]="emailAddress"
                  [firstName]="firstName"
                  [lastName]="lastName"
                  [phoneNumber]="phoneNumber"
  ></ua-signup-form>

  <div *ngIf="authError" class="text-danger text-center mb-3">{{authError}}</div>
</div>
